import { omitBy, isNil, isEmpty, isUndefined, find } from "lodash";
import statesCities from "Components/profile/profile-details/addresses/country_MY.json";
import { useEffect } from "react";
import CryptoJS from "crypto-js";

import { CustomerFormInputType } from "../../../types/customer-form.types";

const model = (data: CustomerFormInputType) => {
  return omitBy(
    {
      org: omitBy(
        {
          _id: data._id ? data._id : undefined,
          name: !isEmpty(data.customerName) ? data.customerName : undefined,
          orgType: data.orgType,
          primaryEmail: !isEmpty(data.emailAddress)
            ? data.emailAddress
            : undefined,
          primaryPhone: {
            countryCode: data.mobileNo.dialCode,
            number: data.mobileNo.number,
            fullNumber: `${data.mobileNo.dialCode}${data.mobileNo.number}`,
            type: "MOBILE",
          },
          contact: {
            fullName: data.customerName,
          },
          customerType: data.customerType,
          prefix: data.prefix,
          customerOrderTypes: data?.parcelTypes,
          allowPickupAll: data?.allowPickupAll
        },
        (value) => isUndefined(value),
      ),
      superAdminPassword: data.password
        ? CryptoJS.SHA256(data.password).toString(CryptoJS.enc.Hex)
        : undefined,
      parentOrgID: data._id
        ? undefined
        : data.parentOrgID
        ? data.parentOrgID
        : undefined,
      file: !isEmpty(data.file)
        ? data.file?.file_url
          ? undefined
          : data.file
        : undefined,
      location: omitBy(
        {
          primary: true,
          _id: data.locationID ? data.locationID : undefined,
          orgName: data.customerName,
          coordinate: data.coordinates,
          address: omitBy(
            {
              street1: data.street1,
              street2: data.street2 ? data.street2 : undefined,
              city: data.city,
              cityCode: find(
                find(
                  statesCities.STATES,
                  (element) => data.state === element.NAME,
                )?.CITIES,
                (element) => element.NAME === data.city,
              )?.CODE,
              state: data.state,
              stateCode: find(
                statesCities.STATES,
                (element) => data.state === element.NAME,
              )?.CODE,
              postcode: data.postcode,
              country: data.country,
            },
            (value) => isUndefined(value),
          ),
          orgType: data.orgType,
          contactPerson: !isEmpty(data.customerName)
            ? data.customerName
            : undefined,
          contactNumber: {
            countryCode: data.mobileNo.dialCode,
            number: data.mobileNo.number,
            fullNumber: `${data.mobileNo.dialCode}${data.mobileNo.number}`,
            type: "MOBILE",
          },
        },
        (value) => isUndefined(value),
      ),
    },
    (value) => isUndefined(value),
  );
};

export default model;
